module.exports = __webpack_public_path__ + "assets/img/qbbbook.03ecccaf.png";